query allHockeyPlayers($first: Int, $offset: Int, $filter: HockeyPlayerFilter, $condition: HockeyPlayerCondition) {
  players: allHockeyPlayers(first: $first, offset: $offset, filter: $filter, condition: $condition) {
    nodes {
      playerMappings: hockeyPlayerMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
          playerIndex
          playerTeamMapping: playerTeamMappingsByFeedAndPlayerExtId {
            nodes {
              discriminator
              team: hockeyTeamMapping {
                extRef
              }
            }
          }
        }
      }
      name
      source
      playerId
      playerIndex
    }
    totalCount
  }
}
